import { create } from 'zustand';

// @TODO: shared로 auth 로직 옮기기
// eslint-disable-next-line boundaries/element-types
import { loginLogic } from '@_features/auth';
import { IUseFolderListOrderStore } from '../../model';

export const useFolderListOrderStore = create<IUseFolderListOrderStore>((set) => ({
	order: loginLogic.isLogin() ? 'manual' : 'alphabetical',
	setOrder: (order) => set({ order }),
}));
